module.exports = __webpack_public_path__ + "img/copy-white.f530ce36.svg";